export class ClientConfigurations {

  public _environment: any;
  public _apiUrl: string = location.origin + "/data-service";
  public _authApiUrl: string = location.origin + "/auth-service";
  public _disableClientCookie: boolean;
  public _cookieProperty: any;
  public _cmsVideoBaseUrl: string = 'https://fingresscdn.azureedge.net/';
  public _cmsBaseUrl: string = 'https://fingresscdn.azureedge.net/';
   public _cdnBaseUrl: string = 'https://fingressstorage.blob.core.windows.net/';
  public _businessCodeUrl: string;
  public _anonymousUserAutoLoginEnabled: boolean;
  public _hideHeader: boolean;
  public _cacheHttpRequest: boolean;
  public _tokenKey: string;
  public _customFooter: string;
  public _customPageId: string = "ab287963-53a5-48e4-a28e-4ddb40422a60";
  public _customAppId: string = "bc6abfa0-dc63-4dec-8ff0-02f84c5a2bc4";
  public _defaultContextFilter: string;
  public _isLayoutCacheEnabled: boolean;
  public _setLocationContext: boolean;
  public _sslEnabled: boolean;
  public _ssoLoginEnabled: boolean;
  public _appVersion: string = "?v=1.2.9";
  public _LDAPLoginEnabled: boolean;
  public _generateClientId: boolean;
  public _postLoginLandingAppId: string ="44b4eb67-f5b8-482b-934f-a03d7f8796be";
  public _postLoginLandingPageId: string ="b6dfd566-f96b-4d19-a4b4-b1ea48779950";
  public _postLogoutLandingAppId: string = "bc6abfa0-dc63-4dec-8ff0-02f84c5a2bc4";
  public _postLogoutLandingPageId: string = "ab287963-53a5-48e4-a28e-4ddb40422a60";
  public _customHeader: boolean;
  public _appId: string;
  public _enableDateShifter: boolean;
  public _studioObjectMode: string;
  public _cspEnabled: boolean;
  public _e2eeEnabled: boolean = true;
  public _fgPublicKey: string = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCD1GYYYeq5D6OC6IhP0dnwG/81K/XPnaF5LsLzJbPsGr2+EbvYNlG4rJ2BORIrFpBNekFR47bEZomk2Qm8alaq9d+D1TenLkXYD574YF/fVmLuedG8WJjvQZ6sN207wu0Zn565mPLwEAYekr6iMJ30QNqezqM+CqRuPfAJqfHsaQIDAQAB";
  public _fgSignPrivateKey: string = "MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAIPUZhhh6rkPo4LoiE/R2fAb/zUr9c+doXkuwvMls+wavb4Ru9g2UbisnYE5EisWkE16QVHjtsRmiaTZCbxqVqr134PVN6cuRdgPnvhgX99WYu550bxYmO9Bnqw3bTvC7RmfnrmY8vAQBh6SvqIwnfRA2p7Ooz4KpG498Amp8expAgMBAAECgYBPy5/kwFgonlu14HSqA/bsDLZEhBBtFBfqVzCvprGqh2E0jF1seSysIOfRkS77H9RG4WpqW/CEHyDPxIPNJXzBbUf0p5akWE6IbwbxTXxnmDaO9mXpSmLzxQWnDbiJUAKsYYMaSB+5dmWcxaP4RT8q+2lca5uRY3Yejec5T85o5QJBAMrQDtjAzKBRkzipiN0H0fkCGXQ04eSk/aqeNkPt34lB/hFQM7YukAElkVnnfAh7mCLki0+k5eAqNrpk8oEif9cCQQCmZtsWoYLaZUASzh6NaB08c7aw84s8Sm5iyoKDdm9bJ7oM3Hx7U1IcjSqI9GIvVv+uZIICwljegTMHURekqm2/AkEAohvrwhVZeku6AXCBlSrLCt5CukAKz1eR6u7LMUDRjETTb8NLkjNlp4T/yXzeB2nDESDcuax0kdksJZDKxa1twQJBAIfEpD1yyjEnK4AsbQEzUadhQk5eZ9xpXmd8k8Bvgav+Xe7gdzCoavagt3PG8dVuRm8j0nAt4hSpldkCcSgJZkECQESOjeWO4jGoPa9Cmfa3p1YBJpLDWMqA+1+rKz7x6MxQYamANCjEWYVgZxtj9xsSBNzeTwa45DmqUDKB1dU8neY=";
	public _fgAesSecretKey: string = "KrL0pe+iFQyNMpZ/Kc/JrMj4y1a79i3cPtpNi1S8/8A=";
  public _disableNavigation: boolean = false;
  public _disableApplicationMenu: boolean = false;


  public static environment: any;
  public static apiUrl: string = location.origin + "/data-service";
  public static authApiUrl: string = location.origin + "/auth-service";
  public static disableClientCookie: boolean = false;
  public static cookieProperty: any = { path: "/", domain: "localhost", "secure": true };
  public static cmsVideoBaseUrl: string = 'https://fingresscdn.azureedge.net/';
  public static cmsBaseUrl: string = 'https://fingresscdn.azureedge.net/';
  public static cdnBaseUrl: string = 'https://fingressstorage.blob.core.windows.net/';
  public static businessCodeUrl: string = 'https://fingresscdn.azureedge.net/resources/img/leasing/FgBusinessCodes.json';
  public static anonymousUserAutoLoginEnabled: boolean = true;
  public static hideHeader: boolean = false;
  public static cacheHttpRequest: boolean = true;
  public static tokenKey: string = "fgToken";
  public static customFooter: string = "";
  public static customPageId: string = "";
  public static customAppId: string = "";
  public static defaultContextFilter: string = 'HO';
  public static isLayoutCacheEnabled: boolean = false;
  public static setLocationContext: boolean = true;
  public static sslEnabled: boolean = true;
  public static ssoLoginEnabled: boolean = false;
  public static appVersion: string = "?v=1.2.4";
  public static LDAPLoginEnabled: boolean = false;
  public static generateClientId: boolean = true;
  public static postLoginLandingPageId: string = "";
  public static postLoginLandingAppId: string = "";

  public static appId: string = "demoApp";
  public static studioObjectMode: string = "prod";
  public static enableDateShifter: boolean = true;
  public static customHeader: boolean = true;
  public static postLogoutLandingAppId: string = "";
  public static postLogoutLandingPageId: string = "";
  public static cspEnabled: boolean = false;
  public static e2eeEnabled: boolean = true;
  public static fgPublicKey: string = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCD1GYYYeq5D6OC6IhP0dnwG/81K/XPnaF5LsLzJbPsGr2+EbvYNlG4rJ2BORIrFpBNekFR47bEZomk2Qm8alaq9d+D1TenLkXYD574YF/fVmLuedG8WJjvQZ6sN207wu0Zn565mPLwEAYekr6iMJ30QNqezqM+CqRuPfAJqfHsaQIDAQAB";
  public static fgSignPrivateKey?: string = 'MIICdwIBADANBgkqhkiG9w0BAQEFAASCAmEwggJdAgEAAoGBAIPUZhhh6rkPo4LoiE/R2fAb/zUr9c+doXkuwvMls+wavb4Ru9g2UbisnYE5EisWkE16QVHjtsRmiaTZCbxqVqr134PVN6cuRdgPnvhgX99WYu550bxYmO9Bnqw3bTvC7RmfnrmY8vAQBh6SvqIwnfRA2p7Ooz4KpG498Amp8expAgMBAAECgYBPy5/kwFgonlu14HSqA/bsDLZEhBBtFBfqVzCvprGqh2E0jF1seSysIOfRkS77H9RG4WpqW/CEHyDPxIPNJXzBbUf0p5akWE6IbwbxTXxnmDaO9mXpSmLzxQWnDbiJUAKsYYMaSB+5dmWcxaP4RT8q+2lca5uRY3Yejec5T85o5QJBAMrQDtjAzKBRkzipiN0H0fkCGXQ04eSk/aqeNkPt34lB/hFQM7YukAElkVnnfAh7mCLki0+k5eAqNrpk8oEif9cCQQCmZtsWoYLaZUASzh6NaB08c7aw84s8Sm5iyoKDdm9bJ7oM3Hx7U1IcjSqI9GIvVv+uZIICwljegTMHURekqm2/AkEAohvrwhVZeku6AXCBlSrLCt5CukAKz1eR6u7LMUDRjETTb8NLkjNlp4T/yXzeB2nDESDcuax0kdksJZDKxa1twQJBAIfEpD1yyjEnK4AsbQEzUadhQk5eZ9xpXmd8k8Bvgav+Xe7gdzCoavagt3PG8dVuRm8j0nAt4hSpldkCcSgJZkECQESOjeWO4jGoPa9Cmfa3p1YBJpLDWMqA+1+rKz7x6MxQYamANCjEWYVgZxtj9xsSBNzeTwa45DmqUDKB1dU8neY=';
	public static fgAesSecretKey?: string = "KrL0pe+iFQyNMpZ/Kc/JrMj4y1a79i3cPtpNi1S8/8A=";
  public static disableNavigation?: boolean = false;
  public static disableApplicationMenu?: boolean = false; 




  constructor() {
    ClientConfigurations.environment = this._environment;
    ClientConfigurations.apiUrl = this._apiUrl;
    ClientConfigurations.authApiUrl = this._authApiUrl;
    ClientConfigurations.disableClientCookie = this._disableClientCookie;
    ClientConfigurations.cookieProperty = this._cookieProperty;
    ClientConfigurations.cmsVideoBaseUrl = this._cmsVideoBaseUrl;
    ClientConfigurations.cmsBaseUrl = this._cmsBaseUrl;
     ClientConfigurations.cdnBaseUrl = this._cdnBaseUrl;
    ClientConfigurations.businessCodeUrl = this._businessCodeUrl;
    ClientConfigurations.anonymousUserAutoLoginEnabled = this._anonymousUserAutoLoginEnabled;
    ClientConfigurations.hideHeader = this._hideHeader;
    ClientConfigurations.cacheHttpRequest = this._cacheHttpRequest;
    ClientConfigurations.tokenKey = this._tokenKey;
    ClientConfigurations.customFooter = this._customFooter;
    ClientConfigurations.customPageId = this._customPageId;
    ClientConfigurations.customAppId = this._customAppId;
    ClientConfigurations.defaultContextFilter = this._defaultContextFilter;
    ClientConfigurations.isLayoutCacheEnabled = this._isLayoutCacheEnabled;
    ClientConfigurations.setLocationContext = this._setLocationContext;
    ClientConfigurations.sslEnabled = this._sslEnabled;
    ClientConfigurations.ssoLoginEnabled = this._ssoLoginEnabled;
    ClientConfigurations.appVersion = this._appVersion;
    ClientConfigurations.LDAPLoginEnabled = this._LDAPLoginEnabled;
    ClientConfigurations.generateClientId = this._generateClientId;
    ClientConfigurations.postLoginLandingPageId = this._postLoginLandingPageId;
    ClientConfigurations.postLoginLandingAppId = this._postLoginLandingAppId;

    ClientConfigurations.customHeader = this._customHeader;
    ClientConfigurations.appId = this._appId;
    ClientConfigurations.studioObjectMode = this._studioObjectMode;
    ClientConfigurations.enableDateShifter = this._enableDateShifter;
    ClientConfigurations.postLogoutLandingAppId = this._postLogoutLandingAppId;
    ClientConfigurations.postLogoutLandingPageId = this._postLogoutLandingPageId;
    ClientConfigurations.cspEnabled = this._cspEnabled;
    ClientConfigurations.e2eeEnabled = this._e2eeEnabled;
    ClientConfigurations.fgPublicKey = this._fgPublicKey;
    ClientConfigurations.fgSignPrivateKey = this._fgSignPrivateKey;
		ClientConfigurations.fgAesSecretKey = this._fgAesSecretKey;
    ClientConfigurations.disableNavigation = this._disableNavigation;
    ClientConfigurations.disableApplicationMenu = this._disableApplicationMenu;
  }
}